import { useLocation } from "@aviv-unified-frontend/runtime/router";
import { getFeaturesEnabled } from "@/utils";
export const useIsNavbar = () => {
    var _a;
    const { search } = useLocation();
    const { navigationBarTabs, navigationBarTags } = getFeaturesEnabled({}, search);
    const isNavigationBar = (_a = (navigationBarTabs || navigationBarTags)) !== null && _a !== void 0 ? _a : false;
    return isNavigationBar;
};
